export const uniqueRole = ["Fighter", "Mage", "Assassin", "Marksman", "Support", "Tank"];
